export default ({ $config, store, redirect, app }) => {
  if (!$config.features.payment || !store.getters["user/isPaymentAllowed"])
    return redirect(app.localePath("/account"))
}
